import { Icon } from 'components/atoms/Icon';
import { cn } from 'utils/cn';
import { localize } from 'i18n/localize';

const $t = localize();

export type MessageState = 'UNREAD' | 'READ' | 'NONE';

type Props = {
	className?: string;
	isWithBg?: boolean;
	state?: MessageState;
	onClick?: () => void;
};

export function MessengerButton({ className, isWithBg, state = 'NONE', onClick }: Props) {
	if (state === 'NONE') {
		return null;
	}

	const title = state === 'UNREAD' ? $t.messengerButton.titleUnread : $t.messengerButton.titleRead;
	return (
		<button
			className={cn(
				'leading-0',
				isWithBg && 'p-2.5 bg-white rounded-full',
				state === 'UNREAD' && 'text-red hover:text-red-hover',
				state === 'READ' && 'text-dark-blue-50 hover:text-dark-blue',
				className,
			)}
			data-test="messenger-button"
			onClick={onClick}
			type="button"
			title={title}
		>
			<Icon type="mail" fill size={20} />
		</button>
	);
}
